import React, { useState, useRef, useEffect } from "react";
import {
  message,
  Input,
  Button,
  Form,
  Space,
  Tooltip,
  Drawer,
  Upload,
  Modal,
  DatePicker,
  Image,
  Col,
  Row,
  Card,
  Select,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

import {
  deleteDepartment,
  getPagingDepartments,
  createDepartment,
  updateDepartment,
  uploadImage,
  deleteImage,
  getAllGroups,
  insertGroup,
  deleteManyDepartment,
  getDepartmentManagementPage,
} from "../../helpers/helper";
import * as url from "../../helpers/url_helper";
import { getImageNameFromURL } from "../../helpers/common";
import Editor from "../../Components/Common/Editor";
import imageDefault from "../../assets/images/placeholder.jpg";
import DataTable from "../../Components/Common/DataTable";
import CreateGroupModal from "./components/CreateGroup";
import { Trans, useTranslation } from "react-i18next";

const { Option } = Select;
const { confirm } = Modal;
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const Roles = () => {
  const { t } = useTranslation();
  document.title = t("managerDepartment");

  const [form] = Form.useForm();
  const [formGroup] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [listDataDepartment, setListDataDepartment] = useState([]);
  const [listGroup, setListGroup] = useState([]);
  const [listCompany, setListCompany] = useState([]);
  const [listGroupReset, setListGroupReset] = useState([]);
  const [visibleForm, setVisibleForm] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");
  const [isCreateGroupModalVisible, setCreateGroupModalVisible] =
    useState(false);
  const [content, setContent] = useState("");

  //pagination
  const [totalPage, setTotalPage] = useState(1);
  const [indexPage, setPageIndex] = useState(1);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);

  //image
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);
  const [fileList, setFileList] = useState([]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingDeleteRows, setLoadingDeleteRows] = useState(false);
  const [imageDeletes, setImageDeletes] = useState([]);
  const refId = useRef(uuidv4());
  const [currentUploadLogo, setCurrentUploadLogo] = useState(null);

  const getAllData = async (_prams, indexPage) => {
    try {
      const params = _prams
        ? _prams
        : {
            pageIndex: indexPage,
            pageSize: pageSize,
            search: "",
          };
      const dataRes = await getPagingDepartments(params);
      setTotalPage(dataRes?.totalPages);
      if (!dataRes) {
        message.error(t("requiredPermission"));
        return false;
      }
      const data = convertDataTable(dataRes.data);
      return dataRes?.data ? data : false;
    } catch (error) {
      message.error(t("requiredPermission"));
      setTotalPage(0);
      return [];
    }
  };

  const convertDataTable = (dataArray) => {
    const data =
      dataArray.length > 0 &&
      dataArray.map((item) => {
        return {
          key: item._id,
          description: item.description,
          departmentName: item.departmentName,
          departmentLogo: item.departmentLogo,
          companyName: item.company?.companyName,
          companyId: item.company?._id,
          groups: item.groups,
          createdTime: moment(new Date(item.createdTime)).format(
            "DD/MM/YYYY HH:mm"
          ),
        };
      });
    return dataArray ? data : [];
  };

  // const getAllGroup = async () => {
  //   try {
  //     const dataRes = await getAllGroups();
  //     if (!dataRes) {
  //       message.error(t("requiredPermission"));
  //       return false;
  //     }
  //     const data =
  //       dataRes.length > 0 &&
  //       dataRes.filter((item) => item.department === null);

  //     return dataRes ? data : [];
  //   } catch (error) {
  //     message.error(t("requiredPermission"));
  //     return [];
  //   }
  // };

  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      try {
        const data = await getDepartmentManagementPage();

        setTotalPage(data.dataPage?.totalPages);

        const dataShowTable = convertDataTable(data.dataPage?.data);
        setListDataDepartment(dataShowTable);

        setListCompany(data.allCompanies);

        // const dataResGroup = data.allGroups.filter(
        //   (item) => item.department === null
        // );
        // setListGroup(dataResGroup || []);

        setLoading(false);
      } catch (error) {
        message.error(t("requiredPermission"));
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const onFinish = async (data) => {
    try {
      const dataReq = {
        departmentName: data.departmentName.trim().replace(/\s-\s/g, "-"),
        description: content,
        departmentLogo: previewImage,
        // groups: data.groups,
      };
      if (data.companyName) {
        const dataCompany = listCompany.filter(
          (item) => item.companyName === data.companyName
        );
        dataReq.company = dataCompany[0]._id;
      }

      // if (data.groups && data.groups.length > 0) {
      //   const newGroups = await Promise.all(
      //     data.groups.map(async (item) => {
      //       if (item?.startsWith("groupName_")) {
      //         const dataRes = await insertGroup({
      //           groupName: item.split("groupName_")[1],
      //         });
      //         if (dataRes.status === 1) {
      //           return dataRes.data._id;
      //         }
      //       } else {
      //         return item;
      //       }
      //     })
      //   );
      //   dataReq.groups = newGroups;
      // }

      if (!data.id) {
        if (currentUploadLogo) {
          const formData = new FormData();
          formData.append("image", currentUploadLogo);
          const responseImage = await uploadImage(formData);
          const { imageName } = responseImage.data;
          dataReq.departmentLogo = imageName;
        }
        const dataRes = await createDepartment(dataReq);
        dataRes.status === 1
          ? message.success(t("saveSuccess"))
          : message.error(`${t("saveFail")} ${dataRes.message}`);
        handleRefresh();
        formSearch.resetFields();
      } else {
        const department = listDataDepartment.find(
          (department) => department.key === data.id
        );

        if (
          currentUploadLogo &&
          data.departmentLogo !== department.departmentLogo
        ) {
          const formData = new FormData();
          formData.append("image", currentUploadLogo);
          const responseImage = await uploadImage(formData);
          const { imageName } = responseImage.data;
          dataReq.departmentLogo = imageName;
          if (department.departmentLogo) {
            await deleteImage(department.departmentLogo);
          }
        } else if (data.departmentLogo === "") {
          if (department.departmentLogo) {
            await deleteImage(department.departmentLogo);
          }
        }

        // const groupOrigin = department.groups.map((item) => item._id);
        // const equalArray =
        //   JSON.stringify(data.groups) === JSON.stringify(groupOrigin);
        if (
          data.companyName === department.companyName &&
          data.departmentName === department.departmentName &&
          data.departmentLogo === department.departmentLogo &&
          content === department.description
        ) {
          message.success("Dữ liệu bộ phận không thay đổi!");
        } else {
          const dataRes = await updateDepartment(data.id, dataReq);
          dataRes.status === 1
            ? message.success(`Sửa bộ phận thành công!`)
            : message.error(`Sửa bộ phận không thành công!`);
          handleRefreshData();
        }
        for (const imageName of imageDeletes) {
          await deleteImage(imageName);
        }
      }
      setFileList([]);
      form.resetFields();
      setCurrentUploadLogo(null);
      handleCloseDrawer();
    } catch (error) {
      console.log(error);
      if (!data.id) {
        message.error(t("permisstionDeniedAction"));
      } else {
        message.error(t("permisstionDeniedAction"));
      }
      formSearch.resetFields();
      form.resetFields();
      setCurrentUploadLogo(null);
      handleCloseDrawer();
    }
  };

  const handleRefresh = async () => {
    formSearch.resetFields();
    const _params = {
      pageIndex: 1,
      pageSize: 10,
      search: "",
    };
    const dataRes = await getAllData(_params, indexPage);
    setListDataDepartment(dataRes.length > 0 ? dataRes : listDataDepartment);
    setContent("");
    setPageIndex(1);
    // const dataResGroup = await getAllGroup();
    // setListGroup(dataResGroup || []);
  };

  const handleSearch = async () => {
    const dataForm = formSearch.getFieldsValue();
    if (!Object.values(dataForm).some((item) => !!item)) {
      return;
    }
    const params = {
      pageIndex: 1,
      pageSize: pageSize,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(params, 1);
    setListDataDepartment(dataRes.length > 0 ? dataRes : false);
    setPageIndex(1);
  };

  const onPageChange = (page, page_size) => {
    setPageIndex(page);
    setPageSize(page_size);
    onPageChangeAtSearch(page, page_size);
  };

  const onPageChangeAtSearch = async (indexPage, page_size) => {
    setLoading(true);

    const params = {
      pageIndex: indexPage,
      pageSize: page_size,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(params, indexPage);
    setListDataDepartment(dataRes.length > 0 ? dataRes : false);
    setLoading(false);
  };

  const onEdit = (key) => {
    const dataEdit = listDataDepartment.filter((item) => item.key === key);
    form.setFieldsValue({
      departmentName: dataEdit[0].departmentName,
      departmentLogo: dataEdit[0].departmentLogo,
      companyName: dataEdit[0].companyName,
      id: dataEdit[0].key,
      // groups: dataEdit[0].groups
      //   ? dataEdit[0].groups.map((value) => {
      //       return value._id;
      //     })
      //   : [],
    });
    // if (dataEdit[0].groups.length > 0) {
    //   setListGroup(dataEdit[0].groups.concat(listGroup));
    // }
    // setListGroupReset(dataEdit[0].groupIds);
    setContent(dataEdit[0].description);
    if (dataEdit[0].departmentLogo) {
      setFileList([
        {
          url: `${process.env.REACT_APP_API_URL}${url.API_IMAGE_GET_BY_ID}/${dataEdit[0].departmentLogo}`,
          name: dataEdit[0].departmentLogo,
        },
      ]);
      setPreviewImage(`${dataEdit[0].departmentLogo}`);
    } else {
      setFileList([]);
      setPreviewImage("");
    }
    setPreviewTitle(dataEdit[0].departmentLogo);
    setDrawerTitle(t("editDepartment"));
    showDrawer();
  };
  const getFormSearch = () => {
    const dataForm = formSearch.getFieldsValue();
    return {
      departmentName: dataForm.departmentName || "",
      companyName: dataForm.companyName || "",
      createdTime: dataForm.createdTime || "",
    };
  };
  const handleRefreshData = async (index_page) => {
    const _params = {
      pageIndex: index_page ? index_page : indexPage,
      pageSize: pageSize,
      ...getFormSearch(),
    };
    const dataRes = await getAllData(_params);
    setListDataDepartment(dataRes);
    setPageIndex(index_page ? index_page : indexPage);
    // const dataResGroup = await getAllGroup();
    // setListGroup(dataResGroup || []);
  };
  const handleRefreshDataDelete = async (countRemove) => {
    const indexPageNew =
      listDataDepartment.length == countRemove
        ? indexPage === 1
          ? 1
          : indexPage - 1
        : indexPage;
    handleRefreshData(indexPageNew);
  };
  const onDelete = async (key) => {
    try {
      const dataRes = await deleteDepartment(key);

      if (dataRes.status === 1) {
        message.success(t("deleteSuccess"));
        handleRefreshDataDelete(1);
      } else {
        message.error(t("deleteFail"));
      }

      // const dataResGroup = await getAllGroup();
      // setListGroup(dataResGroup || []);
    } catch (error) {
      message.error(t("permisstionDeniedAction"));
    }
  };

  const showModalConfirmDelete = (record) => {
    confirm({
      title: t("confirmDelete"),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        onDelete(record);
      },
      onCancel() {},
    });
  };

  const validateInput = (_, value) => {
    if (!value || value.trim() === "") {
      return Promise.reject();
    }
    return Promise.resolve();
  };
  const handleCancel = () => setPreviewVisible(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  const handleChangeImage = ({ fileList: newFileList }) =>
    setFileList(newFileList);

  const props = {
    onRemove: async (file) => {
      try {
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        setFileList(newFileList);
        if (file.url) {
          const imageName = getImageNameFromURL(file.url);
          setImageDeletes((prevArray) => [...prevArray, imageName]);
          setPreviewImage("");
        }
      } catch (error) {
        message.error(t("permisstionDeniedAction"));
      }
    },
    beforeUpload: async (file) => {
      setCurrentUploadLogo(file);
      file.onSuccess();
    },
    fileList,
    maxCount: 1,
  };

  const columns = [
    {
      title: t("company"),
      dataIndex: "companyName",
    },
    {
      title: t("department"),
      dataIndex: "departmentName",
    },
    {
      title: t("group"),
      dataIndex: "groupNames",
      render: (_, record) => {
        return record.groups.map((group, index) => (
          <p className="mb-0" style={{ display: "inline-block" }} key={index}>
            {group.groupName}
            {index < record.groups.length - 1 && (
              <span style={{ paddingLeft: "5px", paddingRight: "5px" }}>|</span>
            )}
          </p>
        ));
      },
    },
    {
      title: t("logo"),
      dataIndex: "departmentLogo",
      render: (_, record) => {
        var image_avatart = imageDefault;
        if (_) image_avatart = _;
        return (
          <Image
            height={60}
            width={60}
            preview={false}
            src={`${process.env.REACT_APP_API_URL}${url.API_IMAGE_GET_BY_ID}/${record.departmentLogo}`}
            fallback={imageDefault}
          />
        );
      },
    },
    {
      title: t("createdTime"),
      dataIndex: "createdTime",
    },
    {
      title: t("content"),
      dataIndex: "description",
      ellipsis: {
        showTitle: false,
      },
      render: (description) => (
        <div
          dangerouslySetInnerHTML={{
            __html: description ? description.substring(0, 50) + "..." : "",
          }}
        />
      ),
    },
    {
      title: t("action"),
      dataIndex: "",
      render: (_, record) =>
        listDataDepartment.length >= 1 ? (
          <Space>
            <Tooltip title={t("edit")}>
              <Button
                type="primary"
                shape="circle"
                icon={<EditOutlined />}
                size="small"
                onClick={() => onEdit(record.key)}
              />
            </Tooltip>
            <Tooltip title={t("delete")}>
              <Button
                type="danger"
                shape="circle"
                icon={<DeleteOutlined />}
                size="small"
                onClick={() => showModalConfirmDelete(record.key)}
              />
            </Tooltip>
          </Space>
        ) : null,
    },
  ];

  const onClose = async () => {
    setVisibleForm(false);
    setContent("");
    // const dataResGroup = await getAllGroup();
    // setListGroup(dataResGroup || []);
  };

  const showDrawer = () => {
    setVisibleForm(true);
    setImageDeletes([]);
  };

  const handleNewRole = () => {
    setDrawerTitle(t("createDepartment"));
    showDrawer();
    setCurrentUploadLogo(null);
    setFileList([]);
    form.resetFields();
    form.getFieldValue.groups = [];
  };

  const handleCloseDrawer = () => {
    setDrawerTitle("");
    setFileList([]);
    setVisibleForm(false);
    form.resetFields();
    setContent("");
  };

  // const onCreateNewGroup = async (value) => {
  //   value.groupName = value.groupName.trim();
  //   const checkDuplicate = listGroup.some(
  //     (item) => item.groupName === value.groupName
  //   );
  //   if (listGroup.length > 0 && checkDuplicate) {
  //     message.error(t("groupNameNotExists"));
  //     return;
  //   }
  //   setListGroup([
  //     {
  //       groupName: value.groupName,
  //       _id: `groupName_${value.groupName.trim()}`,
  //     },
  //     ...listGroup,
  //   ]);
  //   form.getFieldsValue().groups === undefined
  //     ? form.setFieldsValue({
  //         groups: [`groupName_${value.groupName.trim()}`],
  //       })
  //     : form.setFieldValue({
  //         groups: form
  //           .getFieldsValue()
  //           .groups.push(`groupName_${value.groupName.trim()}`),
  //       });
  //   setCreateGroupModalVisible(false);
  //   formGroup.resetFields();
  // };

  const handleDeleteSelectRows = async () => {
    confirm({
      title: (
        <Trans
          i18nKey="deleteConfirmationDepartment"
          values={{ count: selectedRowKeys.length }}
        />
      ),
      icon: <ExclamationCircleFilled />,
      okText: "Xóa",
      okType: "danger",
      cancelText: "Không",
      onOk() {
        OnDeleteSelectRows();
      },
      onCancel() {},
    });
  };

  const OnDeleteSelectRows = async () => {
    try {
      setLoadingDeleteRows(true);

      const dataRes = await deleteManyDepartment({
        data: { ids: selectedRowKeys },
      });

      if (dataRes.status === 1) {
        message.success(
          <Trans
            i18nKey="deleteManyDepartmentSuccess"
            values={{ count: dataRes.data.deletedCount }}
          />
        );
        handleRefreshDataDelete(dataRes.data.deletedCount);
      } else {
        message.error(t("deleteFail"));
      }

      setSelectedRowKeys([]);
      setLoadingDeleteRows(false);
    } catch (error) {
      message.error(t("permisstionDeniedAction"));
      setLoadingDeleteRows(false);
    }
  };

  return (
    <>
      <div className="page-content">
        <Card>
          <Form form={formSearch} layout="vertical" autoComplete="off">
            <Row gutter={10}>
              <Col hidden={true}>
                <Form.Item name="id" label="Id">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item name="companyName" label={t("companyName") + ":"}>
                  <Input
                    placeholder={t("placeHolderCompanyName")}
                    allowClear={true}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="departmentName"
                  label={t("departmentName") + ":"}
                >
                  <Input
                    placeholder={t("placeHolderDepartmentName")}
                    allowClear={true}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="createdTime" label={t("createdTime") + ":"}>
                  <DatePicker
                    placeholder={t("createdTime")}
                    format={"DD/MM/YYYY"}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item className="">
              <Space>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => handleSearch()}
                >
                  {t("search")}
                </Button>

                <Button type="primary" onClick={handleNewRole}>
                  {t("createDepartment")}
                </Button>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => handleRefresh()}
                >
                  {t("reload")}
                </Button>
                <Button
                  disabled={selectedRowKeys.length == 0}
                  loading={loadingDeleteRows}
                  type="danger"
                  htmlType="button"
                  onClick={() => handleDeleteSelectRows()}
                >
                  {t("delete")}
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>
        <div>
          <Drawer
            title={drawerTitle}
            placement={"right"}
            width={"60%"}
            onClose={onClose}
            open={visibleForm}
            bodyStyle={{
              paddingBottom: 80,
            }}
            style={{ marginTop: "70px" }}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              autoComplete="off"
            >
              <Row gutter={10}>
                <Col hidden={true}>
                  <Form.Item name="id" label="Id">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="companyName"
                    label={t("company")}
                    rules={[
                      {
                        required: true,
                        validator: validateInput,
                        message: t("validateSelectCompany"),
                      },
                      {
                        type: "string",
                        min: 1,
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("placeHolderSelectCompany")}
                      allowClear
                      showSearch
                    >
                      {listCompany.length > 0 &&
                        listCompany.map((item) => {
                          return (
                            <Option key={item._id} value={item.companyName}>
                              {item.companyName}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="departmentName"
                    label={t("department")}
                    rules={[
                      {
                        required: true,
                        validator: validateInput,
                        message: t("validateDepartmentName"),
                      },
                      {
                        type: "string",
                        min: 1,
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("placeHolderDepartmentName")}
                      allowClear={true}
                    />
                  </Form.Item>
                </Col>
                {/* <Col span={24}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Form.Item
                      name="groups"
                      label={t("group")}
                      style={{ width: "80%" }}
                    >
                      <Select
                        mode="multiple"
                        placeholder={t("placeHolderSelectGroup")}
                        allowClear
                        showSearch
                        style={{ width: "100%" }}
                      >
                        {listGroup.length > 0 &&
                          listGroup.map((item) => {
                            return (
                              <Option key={item._id} value={item._id}>
                                {item.groupName}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                    <Button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "20%",
                        margin: "10px 0 0 8px",
                      }}
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => setCreateGroupModalVisible(true)}
                    >
                      {t("createGroup")}
                    </Button>
                  </div>
                </Col> */}
                <Col span={24}>
                  <Form.Item name="departmentLogo" label="Logo" className="">
                    <Space align="start">
                      <Upload
                        {...props}
                        listType="picture-card"
                        onChange={handleChangeImage}
                        onPreview={handlePreview}
                        accept="image/*"
                      >
                        <div>
                          <PlusOutlined />
                          <div
                            style={{
                              marginTop: 8,
                            }}
                          >
                            {t("upload")}
                          </div>
                        </div>
                      </Upload>
                      {previewImage ? (
                        <>
                          <Modal
                            forceRender={true}
                            open={previewVisible}
                            title={previewTitle}
                            footer={null}
                            onCancel={handleCancel}
                          >
                            <img
                              alt={previewTitle}
                              style={{ width: "100%" }}
                              src={previewImage}
                            />
                          </Modal>
                        </>
                      ) : null}
                    </Space>
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <div className="ant-col ant-form-item-label">
                    <label
                      htmlFor="content"
                      className="ant-form-item-required"
                      title={t("content")}
                    >
                      {t("content")}
                    </label>
                  </div>

                  <Editor
                    value={content}
                    onChange={(data) => setContent(data)}
                    refId={refId}
                  />
                </Col>
              </Row>

              <Form.Item className="mt-3">
                <Space>
                  <Button type="primary" htmlType="submit">
                    {t("save")}
                  </Button>
                  <Button type="danger" onClick={handleCloseDrawer}>
                    {t("close")}
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </Drawer>
        </div>
        <DataTable
          listData={listDataDepartment}
          pageSize={pageSize}
          columns={columns}
          indexPage={indexPage}
          totalPage={totalPage}
          onPageChange={onPageChange}
          loading={loading}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      </div>

      {/* <CreateGroupModal
        form={formGroup}
        isShow={isCreateGroupModalVisible}
        onFinish={(value) => onCreateNewGroup(value)}
        onCancel={() => {
          setCreateGroupModalVisible(false);
          formGroup.resetFields();
        }}
      /> */}
    </>
  );
};
export default Roles;
